module.exports = __webpack_public_path__ + "img/asesoramientoestudiantes.aac23d15.png";